import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ContentPasteGoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"content_paste_go"}/>
}
